module.exports = __webpack_public_path__ + "static/media/check.23efa70b.svg";